<template>
    <div class="row">
        <div
            class="col-md-4"
            v-if="lasLocationsIn">
            <div
                class="card"
                style="padding: 5px">
                <div class="card-title text-center">
                    {{ $t('school.connect_a_las_location') }}
                </div>

                <div class="card-body">
                    <div class="row">
                        <div class="col-md-12">
                            <b-form-select
                                v-model="selectedLasLocation"
                                :options="lasLocationsIn"
                                :text-field="$t('common.name')"
                                value-field="id">
                            </b-form-select>
                        </div>
                    </div>
                    <div
                        class="row"
                        style="margin-top: 20px">
                        <div class="col-md-12 d-flex justify-content-between">
                            <button
                                class="col-4 btn btn-primary"
                                @click="back">
                                {{ $t('common.previous') }}
                            </button>

                            <button
                                class="col-4 btn btn-primary"
                                @click="save">
                                {{ $t('common.save') }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'design-2021-school-las-location-component',
    props: ['lasLocationsIn', 'loginIn'],
    data() {
        return {
            selectedLasLocation: null,
        };
    },
    methods: {
        save() {
            this.alert.saving();

            let location = null;
            for (const l of this.lasLocationsIn) {
                if (l.id === this.selectedLasLocation) {
                    location = l;
                    break;
                }
            }

            let data = {
                brin: this.loginIn.brin,
                url: this.loginIn.url,
                username: this.loginIn.username,
                password: this.loginIn.password,

                afkorting: location.afkorting,
                email: location.email,
                fax: location.fax,
                id: location.id,
                naam: location.naam,
                telefoon: location.telefoon,
                vestigingAdresId: location.vestigingAdres.id,
                vestigingAdresNummer: location.vestigingAdres.nummer,
                vestigingAdresPlaats: location.vestigingAdres.plaats,
                vestigingAdresPostcode: location.vestigingAdres.postcode,
                vestigingaddresstraat: location.vestigingAdres.straat,
                vestigingAdresType: location.vestigingAdres.type,
            };

            this.axios.post(this.routes.lasLocationSave(this.selectedLasLocation.id), data).then(
                (response) => {
                    window.location.reload();
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },
        back() {
            this.$emit('previous', true);
        },
    },
};
</script>

<style scoped></style>
